<template>
  <div class="layout-root">
    <Sidebarmenu v-if="!isEditorRoute" ref="sidebar" />
    <div class="layout-content" :class="{ 'full-width': isEditorRoute }">
      <main class="content" :class="{ 'editor-content': isEditorRoute }">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Sidebarmenu from "@/components/Sidebarmenu.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const sidebar = ref();

const isEditorRoute = computed(() => {
  return route.name === 'editor' || route.path.startsWith('/editor/');
});

const toggleSidebar = () => {
  sidebar.value?.toggleSidebar();
};
</script>

<style scoped>
.layout-root {
  display: flex;
  /* Antes fixo em 100vh: quando #app-container ganhou a tarja como irmã
     acima de .conteudo-principal (App.vue), essa altura passou a exceder o
     espaço real disponível (viewport - altura da tarja), com
     `overflow: hidden` cortando o rodapé do sidebar/conteúdo em vez de
     rolar. .conteudo-principal já resolve para a altura real (flex:1;
     min-height:0), então 100% aqui acompanha o espaço de fato disponível. */
  height: 100%;
  padding: 12px;
  gap: 12px;
  overflow: hidden;
}

.layout-root.editor-layout {
  padding: 0;
  gap: 0;
}

.layout-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  min-width: 0;
  overflow: hidden;
}

.layout-content.full-width {
  width: 100%;
}

.content {
  flex: 1;
  padding: 0;
  background-color: var(--background-color);
  border-radius: 12px;
  margin-top: 0;
  overflow: auto;
  /* Barra fina, mas visível: escondida, quem não usa rodinha nem touchpad
     (professora em 05/10/2026) não tinha como chegar aos cards de baixo. */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: var(--p-surface-400, #9ca3af) transparent;
}

.content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.content::-webkit-scrollbar-track {
  background: transparent;
}

.content::-webkit-scrollbar-thumb {
  background-color: var(--p-surface-400, #9ca3af);
  border-radius: 8px;
}

.content::-webkit-scrollbar-thumb:hover {
  background-color: var(--p-surface-500, #6b7280);
}

.content.editor-content {
  margin-top: 0;
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  /* O editor tem as próprias áreas de rolagem; aqui segue escondida. */
  scrollbar-width: none;
}

.content.editor-content::-webkit-scrollbar {
  display: none;
}

@media (max-width: 768px) {
  .layout-root {
    flex-direction: column;
    padding: 8px;
    gap: 8px;
  }

  .layout-content {
    margin-left: 0;
  }

  .content {
    margin-top: 8px;
  }

  .content.editor-content {
    margin-top: 0;
    padding: 8px;
  }
}
</style>
